module.exports = __webpack_public_path__ + "img/banner_sample3.35b3941d.jpg";